import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-033cc21c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lost-found-container" }
const _hoisted_2 = {
  ref: "contentWrapper",
  class: "content-wrapper"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "상태", -1 /* HOISTED */))
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "분실물명", -1 /* HOISTED */))
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "분실노선", -1 /* HOISTED */))
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "분실일시", -1 /* HOISTED */))
const _hoisted_13 = { class: "content" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "btn-group" }
const _hoisted_17 = ["disabled"]
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "분실물 신고를 삭제하시겠습니까?", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "분실물" }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            ($setup.lostFoundDetail?.statusCode)
              ? (_openBlock(), _createElementBlock("p", {
                  key: 0,
                  class: _normalizeClass(["status", [$setup.lostFoundStatusCodeMap[$setup.lostFoundDetail.statusCode]]])
                }, _toDisplayString($setup.lostFoundDetail?.statusName), 3 /* TEXT, CLASS */))
              : _createCommentVNode("v-if", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString($setup.lostFoundDetail?.title), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, _toDisplayString($setup.lostFoundDetail?.lineName ?? $setup.lostFoundDetail?.lineRouteName), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("p", _hoisted_13, _toDisplayString($setup.lostFoundDetail?.lostTs), 1 /* TEXT */)
          ]),
          ($setup.lostFoundDetail?.lostNote)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", {
                  class: "note",
                  innerHTML: $setup.DOMPurify.sanitize($setup.lostNoteHtml)
                }, null, 8 /* PROPS */, _hoisted_15)
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("button", {
              class: "btn edit",
              type: "button",
              disabled: 
              $setup.lostFoundDetail?.statusCode !== $setup.LostFoundStatusCode.STORE
            ,
              onClick: $setup.goToLostEdit
            }, " 수정 ", 8 /* PROPS */, _hoisted_17),
            _createElementVNode("button", {
              class: "btn delete",
              type: "button",
              disabled: 
              $setup.lostFoundDetail?.statusCode !== $setup.LostFoundStatusCode.STORE
            ,
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowLostItemDeleteModal(true)))
            }, " 삭제 ", 8 /* PROPS */, _hoisted_18)
          ]),
          _createVNode($setup["FooterButton"], {
            title: "목록",
            onOnClickFooterButton: $setup.goBack
          })
        ], 512 /* NEED_PATCH */)
      ]),
      ($setup.contentWrapper)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            class: "scroll-top-wrapper",
            container: $setup.contentWrapper
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true),
      ($setup.shouldShowLostItemDeleteModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 1,
            title: "분실물 신고 삭제",
            okButtonTitle: "삭제",
            cancelButtonTitle: "취소",
            onOnClickOkButton: _cache[1] || (_cache[1] = ($event: any) => (
        [$setup.deleteLostItem(), $setup.toggleShowLostItemDeleteModal(false)]
      )),
            onOnClickCancelButton: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowLostItemDeleteModal(false)))
          }, {
            default: _withCtx(() => [
              _hoisted_19
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}